import { InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IFeatureAggregates } from "./reviewsAggregate";

export interface IReviewWidgetFeatureAggregateComponent {
    qualityAverage: number;
    valueForMoneyAverage: number;
    isHidden: boolean;
    update:(qualityAverage: number, valueForMoneyAverage: number) => void;
}

export class ReviewWidgetFeatureAggregateComponent extends InstanceComponentBase implements IReviewWidgetFeatureAggregateComponent {
    public qualityAverage: number;
    public valueForMoneyAverage: number;
    public isHidden: boolean;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.setQualityAverage();
        this.setValueForMoneyAverage();
        this.updatePanelIsHidden();
        this.updateQualityAverageIsHidden();
        this.updateValueForMoneyAverageIsHidden();
    }

    setQualityAverage():void{
        this.qualityAverage = +HelperUtils.getValueForElementAndAttributeOrThrows(this.htmlElement, AttributeEnums.ReviewWidgetFeatureAggregateComponent.qualityAverage);
    }

    writeQualityAverage(qualityAverage: number): void {
        HelperUtils.setValueForElementAndAttributeOrThrows(qualityAverage.toString(), this.htmlElement, AttributeEnums.ReviewWidgetFeatureAggregateComponent.qualityAverage);
    }

    updateQualityAverage(qualityAverage: number):void{
        this.writeQualityAverage(qualityAverage);
        this.setQualityAverage();
        this.setQualityAverageMeterAndValue();
        this.updateQualityAverageIsHidden();
    }

    setQualityAverageMeterAndValue(): void {
        let qualityAverageElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.qualityAverage))
        
        let qualityAverageMeter: HTMLMeterElement = qualityAverageElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.aggregateMeter));
        qualityAverageMeter.value = this.qualityAverage;

        let qualityAverageText: HTMLElement = qualityAverageElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.aggregateTotal));
        qualityAverageText.innerHTML = `${this.qualityAverage} / 5`;
    }

    setValueForMoneyAverage():void{
        this.valueForMoneyAverage = +HelperUtils.getValueForElementAndAttributeOrThrows(this.htmlElement, AttributeEnums.ReviewWidgetFeatureAggregateComponent.valueForMoneyAverage);
    }

    writeValueForMoneyAverage(valueForMoneyAverage: number): void {
        HelperUtils.setValueForElementAndAttributeOrThrows(valueForMoneyAverage.toString(), this.htmlElement, AttributeEnums.ReviewWidgetFeatureAggregateComponent.valueForMoneyAverage);
    }

    updateValueForMoneyAverage(valueForMoneyAverage: number):void{
        this.writeValueForMoneyAverage(valueForMoneyAverage);
        this.setValueForMoneyAverage();
        this.setValueForMoneyAverageMeterAndValue();
        this.updateValueForMoneyAverageIsHidden();
    }

    setValueForMoneyAverageMeterAndValue(): void {
        let valueForMoneyAverageElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.valueForMoneyAverage))
        
        let valueForMoneyAverageMeter: HTMLMeterElement = valueForMoneyAverageElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.aggregateMeter));
        valueForMoneyAverageMeter.value = this.valueForMoneyAverage;

        let valueForMoneyAverageText: HTMLElement = valueForMoneyAverageElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.aggregateTotal));
        valueForMoneyAverageText.innerHTML = `${this.valueForMoneyAverage} / 5`;
    }

    updatePanelIsHiddenCssClass():void{
        console.log(`ReviewWidgetFeatureAggregateComponent: updatePanelIsHiddenCssClass - ${this.isHidden}`);
        if(this.isHidden){
            this.htmlElement.classList.add(StringEnums.CssClass.LbHidden);
        }else{
            this.htmlElement.classList.remove(StringEnums.CssClass.LbHidden);
        }
    }
    
    updatePanelIsHidden():void{
        if(this.qualityAverage >= 4 || this.valueForMoneyAverage >= 4) {
            this.isHidden = false;
            this.updatePanelIsHiddenCssClass();
        }else{
            this.isHidden = true;
            this.updatePanelIsHiddenCssClass();
        }
    }

    updateQualityAverageIsHidden(): void {
        let meterElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.qualityAverage))
        if (this.qualityAverage >= 4) {
            meterElement.classList.remove(StringEnums.CssClass.LbHidden);
        } else {
            meterElement.classList.add(StringEnums.CssClass.LbHidden);
        }
    }     

    updateValueForMoneyAverageIsHidden(): void {
        let meterElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.valueForMoneyAverage))
        if (this.valueForMoneyAverage >= 4) {
            meterElement.classList.remove(StringEnums.CssClass.LbHidden);
        } else {
            meterElement.classList.add(StringEnums.CssClass.LbHidden);
        }
    }

    update(qualityAverage: number, valueForMoneyAverage: number):void{
        this.updateQualityAverage(qualityAverage);
        this.updateValueForMoneyAverage(valueForMoneyAverage);
        this.updatePanelIsHidden();
    }

    dispose()
    {

    };

}